import React from 'react';

const About = () => (
    <p>About</p>
);

export default About;